import { render, staticRenderFns } from "./RingChart2.vue?vue&type=template&id=3434329c&scoped=true&"
import script from "./RingChart2.vue?vue&type=script&lang=js&"
export * from "./RingChart2.vue?vue&type=script&lang=js&"
import style0 from "./RingChart2.vue?vue&type=style&index=0&id=3434329c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3434329c",
  null
  
)

export default component.exports